"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridClientTransport = exports.HybridClientTransportGeneric = void 0;
var transport_websocket_client_1 = require("./transport.websocket.client");
var transport_http_client_1 = require("./transport.http.client");
var HybridClientTransportGeneric = (function () {
    function HybridClientTransportGeneric(restEndpoint, wsEndpoint, marshaller, logger) {
        this._headers = {};
        this._restTransport = new transport_http_client_1.HTTPClientTransport(restEndpoint, marshaller, logger);
        this._wsTransport = new transport_websocket_client_1.WebSocketClientTransport(wsEndpoint, marshaller, logger);
    }
    Object.defineProperty(HybridClientTransportGeneric.prototype, "onSend", {
        get: function () {
            return this._restTransport.onSend;
        },
        set: function (value) {
            this._restTransport.onSend = value;
            this._wsTransport.onSend = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HybridClientTransportGeneric.prototype, "onSuccess", {
        get: function () {
            return this._restTransport.onSuccess;
        },
        set: function (value) {
            this._restTransport.onSuccess = value;
            this._wsTransport.onSuccess = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HybridClientTransportGeneric.prototype, "onFailure", {
        get: function () {
            return this._restTransport.onFailure;
        },
        set: function (value) {
            this._restTransport.onFailure = value;
            this._wsTransport.onFailure = value;
        },
        enumerable: false,
        configurable: true
    });
    HybridClientTransportGeneric.prototype.setContext = function (context) {
        this._wsTransport.setContext(context);
    };
    HybridClientTransportGeneric.prototype.getContext = function () {
        return this._wsTransport.getContext();
    };
    HybridClientTransportGeneric.prototype.registerBuzzer = function (buzzer) {
        return this._wsTransport.registerBuzzer(buzzer);
    };
    HybridClientTransportGeneric.prototype.unregisterBuzzer = function (id) {
        return this._wsTransport.unregisterBuzzer(id);
    };
    HybridClientTransportGeneric.prototype.getHTTPTransport = function () {
        return this._restTransport;
    };
    HybridClientTransportGeneric.prototype.getWebsocketTransport = function () {
        return this._wsTransport;
    };
    HybridClientTransportGeneric.prototype.getAuthorization = function () {
        return this._authMethod;
    };
    HybridClientTransportGeneric.prototype.setAuthorization = function (method) {
        this._authMethod = method;
        this._restTransport.setAuthorization(method);
        this._wsTransport.setAuthorization(method);
    };
    HybridClientTransportGeneric.prototype.getHeaders = function () {
        return this._headers;
    };
    HybridClientTransportGeneric.prototype.setHeaders = function (headers) {
        this._headers = headers || {};
        this._restTransport.setHeaders(headers);
        this._wsTransport.setHeaders(headers);
    };
    HybridClientTransportGeneric.prototype.send = function (service, method, data) {
        if (this._wsTransport.isReady()) {
            return this._wsTransport.send(service, method, data);
        }
        return this._restTransport.send(service, method, data);
    };
    return HybridClientTransportGeneric;
}());
exports.HybridClientTransportGeneric = HybridClientTransportGeneric;
var HybridClientTransport = (function (_super) {
    __extends(HybridClientTransport, _super);
    function HybridClientTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HybridClientTransport;
}(HybridClientTransportGeneric));
exports.HybridClientTransport = HybridClientTransport;
//# sourceMappingURL=transport.hybrid.client.js.map